import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import { connect } from 'react-redux';
import { updateURL, init } from 'redux/modules/imagePicker';
import * as styles from './ImagePicker.scss';
var ImagePickerURL = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    urlImageUploadError: state.imagePicker.urlImageUploadError,
    hasValidUrlLink: state.imagePicker.hasValidUrlLink,
    urlString: state.imagePicker.urlString
  };
}, {
  init: init,
  updateURL: updateURL
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ImagePickerURL, _Component);

  var _super = _createSuper(ImagePickerURL);

  function ImagePickerURL(props) {
    var _this;

    _classCallCheck(this, ImagePickerURL);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      imgLoadError: null
    });

    var key = '13292995-e70ed88611ab433d88f8f56bc';
    _this.state = {
      urlValue: ''
    };
    return _this;
  }

  _createClass(ImagePickerURL, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.contentWrap,
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement(TextField, {
        value: this.props.urlString,
        onChange: function onChange(e) {
          _this2.props.updateURL(e.target.value);

          _this2.setState({
            imgLoadError: null
          });
        },
        fixedFloatingLabel: true,
        floatingLabelText: this.props.urlString.length ? 'Image URL' : 'Paste an image URL here',
        style: {
          marginLeft: '2%',
          width: '96%',
          marginBottom: 16
        }
      }), this.props.urlImageUploadError || this.state.imgLoadError ? /*#__PURE__*/React.createElement("div", {
        style: {
          color: 'red',
          textAlign: 'center',
          margin: 24,
          marginTop: 8
        }
      }, "Darn. There was a problem using that image. Try again or try a different image url.") : /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 100
        }
      }, !!this.props.urlString.length && this.props.hasValidUrlLink ? /*#__PURE__*/React.createElement("img", {
        onError: function onError(err) {
          return _this2.setState({
            imgLoadError: err.message || true
          });
        },
        src: this.props.urlString,
        style: {
          width: '100%'
        }
      }) : /*#__PURE__*/React.createElement("span", null, "If your URL is correct, you'll see an image preview here."))));
    }
  }]);

  return ImagePickerURL;
}(Component)) || _class);
export { ImagePickerURL as default };